import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleAlert: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-alert, comment, feedback"><path d="M12 7.75V11.75M3.75 3.75H20.25V18.25H15.0155L11.9979 20.75L9.0155 18.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 13.5H12.75V15H11.25V13.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleAlert;
